'use client';

import { c as _c } from "react/compiler-runtime";
import type { DetailDeliveryAddressResponse } from '__generated__/api/auth';
import { Button, Checkbox, Modal } from '@common/components';
import { Input } from '@common/components/atom/Input/Input';
import { InputDecorator } from '@common/components/atom/InputDecorator/InputDecorator';
import { useToast } from '@common/hooks';
import { useMutation } from '@tanstack/react-query';
import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import type { Address } from 'react-daum-postcode';
const DaumPostcodeEmbed = dynamic(() => import('react-daum-postcode'), {
  ssr: false
});
import { AuthMutation } from '@/api';
import { ResponsiveDialog } from '@/components/organism/ResponsiveDialog';
interface AddressFormData {
  recipient: string;
  phone: string;
  zipCode: string;
  address: string;
  detailAddress: string;
  name: string;
  entrancePasscode: string;
  isPrimary: boolean;
}
const initialFormData: AddressFormData = {
  recipient: '',
  phone: '',
  zipCode: '',
  address: '',
  detailAddress: '',
  name: '',
  entrancePasscode: '',
  isPrimary: false
};
interface DeliveryAddressEditModalProps {
  opened: boolean;
  onClose: () => void;
  /** 편집할 주소. null이면 신규 추가 모드 */
  address?: DetailDeliveryAddressResponse | null;
  /** 저장/삭제 성공 시 호출 */
  onSuccess?: () => void;
}
export const DeliveryAddressEditModal = t0 => {
  const $ = _c(120);
  const {
    opened,
    onClose,
    address,
    onSuccess
  } = t0;
  const {
    toast,
    toastError
  } = useToast();
  let t1;
  if ($[0] !== address) {
    t1 = () => {
      if (address) {
        return {
          recipient: address.recipientName ?? "",
          phone: address.recipientNo ?? "",
          zipCode: address.zipCode ?? "",
          address: address.address ?? "",
          detailAddress: address.addressDetail ?? "",
          name: address.name ?? "",
          entrancePasscode: address.entrancePasscode ?? "",
          isPrimary: address.primaryYN ?? false
        };
      }
      return initialFormData;
    };
    $[0] = address;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [formData, setFormData] = useState(t1);
  const [showAddressSearch, setShowAddressSearch] = useState(false);
  let t2;
  let t3;
  if ($[2] !== address || $[3] !== opened) {
    t2 = () => {
      if (opened) {
        if (address) {
          setFormData({
            recipient: address.recipientName ?? "",
            phone: address.recipientNo ?? "",
            zipCode: address.zipCode ?? "",
            address: address.address ?? "",
            detailAddress: address.addressDetail ?? "",
            name: address.name ?? "",
            entrancePasscode: address.entrancePasscode ?? "",
            isPrimary: address.primaryYN ?? false
          });
        } else {
          setFormData(initialFormData);
        }
      }
    };
    t3 = [opened, address];
    $[2] = address;
    $[3] = opened;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = AuthMutation["post:/wello/v2/auth/home/delivery"]();
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== onClose || $[8] !== onSuccess || $[9] !== toast) {
    t5 = () => {
      toast({
        message: "\uBC30\uC1A1\uC9C0\uAC00 \uB4F1\uB85D\uB418\uC5C8\uC5B4\uC694"
      });
      onSuccess?.();
      onClose();
    };
    $[7] = onClose;
    $[8] = onSuccess;
    $[9] = toast;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== toastError) {
    t6 = error => toastError({
      error
    });
    $[11] = toastError;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = {
      ...t4,
      onSuccess: t5,
      onError: t6
    };
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const {
    mutate: createDelivery
  } = useMutation(t7);
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = AuthMutation["put:/wello/v2/auth/home/delivery/{addressId}"]();
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== onClose || $[18] !== onSuccess || $[19] !== toast) {
    t9 = () => {
      toast({
        message: "\uBC30\uC1A1\uC9C0\uAC00 \uC218\uC815\uB418\uC5C8\uC5B4\uC694"
      });
      onSuccess?.();
      onClose();
    };
    $[17] = onClose;
    $[18] = onSuccess;
    $[19] = toast;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== toastError) {
    t10 = error_0 => toastError({
      error: error_0
    });
    $[21] = toastError;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t9) {
    t11 = {
      ...t8,
      onSuccess: t9,
      onError: t10
    };
    $[23] = t10;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const {
    mutate: updateDelivery
  } = useMutation(t11);
  let t12;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = AuthMutation["delete:/wello/v2/auth/home/delivery/{addressId}"]();
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== onClose || $[28] !== onSuccess || $[29] !== toast) {
    t13 = () => {
      toast({
        message: "\uBC30\uC1A1\uC9C0\uAC00 \uC0AD\uC81C\uB418\uC5C8\uC5B4\uC694"
      });
      onSuccess?.();
      onClose();
    };
    $[27] = onClose;
    $[28] = onSuccess;
    $[29] = toast;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== toastError) {
    t14 = error_1 => toastError({
      error: error_1
    });
    $[31] = toastError;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t13 || $[34] !== t14) {
    t15 = {
      ...t12,
      onSuccess: t13,
      onError: t14
    };
    $[33] = t13;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  const {
    mutate: deleteDelivery
  } = useMutation(t15);
  let t16;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = data => {
      let addr = data.address;
      if (data.buildingName) {
        addr = addr + ` (${data.buildingName})`;
        addr;
      }
      setFormData(prev => ({
        ...prev,
        zipCode: data.zonecode,
        address: addr,
        detailAddress: ""
      }));
      setShowAddressSearch(false);
    };
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  const handleAddressComplete = t16;
  let t17;
  if ($[37] !== formData.address || $[38] !== formData.detailAddress || $[39] !== formData.phone || $[40] !== formData.recipient || $[41] !== formData.zipCode || $[42] !== toast) {
    t17 = () => {
      if (!formData.recipient.trim()) {
        toast({
          message: "\uBC1B\uB294 \uBD84\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694",
          type: "fail"
        });
        return false;
      }
      if (!formData.zipCode || !formData.address) {
        toast({
          message: "\uC8FC\uC18C\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694",
          type: "fail"
        });
        return false;
      }
      if (!formData.detailAddress.trim()) {
        toast({
          message: "\uC0C1\uC138\uC8FC\uC18C\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694",
          type: "fail"
        });
        return false;
      }
      if (!formData.phone.trim()) {
        toast({
          message: "\uD734\uB300\uD3F0 \uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694",
          type: "fail"
        });
        return false;
      }
      return true;
    };
    $[37] = formData.address;
    $[38] = formData.detailAddress;
    $[39] = formData.phone;
    $[40] = formData.recipient;
    $[41] = formData.zipCode;
    $[42] = toast;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  const validateForm = t17;
  let t18;
  if ($[44] !== address || $[45] !== createDelivery || $[46] !== formData.address || $[47] !== formData.detailAddress || $[48] !== formData.entrancePasscode || $[49] !== formData.isPrimary || $[50] !== formData.name || $[51] !== formData.phone || $[52] !== formData.recipient || $[53] !== formData.zipCode || $[54] !== updateDelivery || $[55] !== validateForm) {
    t18 = () => {
      if (!validateForm()) {
        return;
      }
      const body = {
        recipientName: formData.recipient,
        recipientNo: formData.phone,
        zipCode: formData.zipCode,
        address: formData.address,
        addressDetail: formData.detailAddress,
        name: formData.name || undefined,
        entrancePasscode: formData.entrancePasscode || undefined,
        primaryYN: formData.isPrimary
      };
      if (address?.addressId) {
        updateDelivery({
          path: {
            addressId: address.addressId
          },
          body
        });
      } else {
        createDelivery({
          body
        });
      }
    };
    $[44] = address;
    $[45] = createDelivery;
    $[46] = formData.address;
    $[47] = formData.detailAddress;
    $[48] = formData.entrancePasscode;
    $[49] = formData.isPrimary;
    $[50] = formData.name;
    $[51] = formData.phone;
    $[52] = formData.recipient;
    $[53] = formData.zipCode;
    $[54] = updateDelivery;
    $[55] = validateForm;
    $[56] = t18;
  } else {
    t18 = $[56];
  }
  const handleSave = t18;
  let t19;
  if ($[57] !== address || $[58] !== deleteDelivery) {
    t19 = () => {
      if (address?.addressId) {
        deleteDelivery({
          path: {
            addressId: address.addressId
          }
        });
      }
    };
    $[57] = address;
    $[58] = deleteDelivery;
    $[59] = t19;
  } else {
    t19 = $[59];
  }
  const handleDelete = t19;
  const t20 = address ? "\uBC30\uC1A1\uC9C0 \uC218\uC815" : "\uC2E0\uADDC \uBC30\uC1A1\uC9C0 \uCD94\uAC00";
  const t21 = address ? "\uBC30\uC1A1\uC9C0 \uC218\uC815" : "\uC2E0\uADDC \uBC30\uC1A1\uC9C0 \uCD94\uAC00";
  let t22;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = e => setFormData(prev_0 => ({
      ...prev_0,
      recipient: e.target.value
    }));
    $[60] = t22;
  } else {
    t22 = $[60];
  }
  let t23;
  if ($[61] !== formData.recipient) {
    t23 = <InputDecorator label={"\uBC1B\uB294 \uBD84"} required={true}><Input dimensions="H40" value={formData.recipient} onChange={t22} placeholder={"\uBC1B\uB294 \uBD84 \uC774\uB984\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694"} /></InputDecorator>;
    $[61] = formData.recipient;
    $[62] = t23;
  } else {
    t23 = $[62];
  }
  let t24;
  if ($[63] !== formData.address) {
    t24 = <Input dimensions="H40" value={formData.address} placeholder={"\uC8FC\uC18C"} disabled={true} className="flex-1" />;
    $[63] = formData.address;
    $[64] = t24;
  } else {
    t24 = $[64];
  }
  let t25;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <Button dimensions="H40" theme="sub-line" onClick={() => setShowAddressSearch(true)} className="shrink-0">주소찾기</Button>;
    $[65] = t25;
  } else {
    t25 = $[65];
  }
  let t26;
  if ($[66] !== t24) {
    t26 = <div className="flex gap-4">{t24}{t25}</div>;
    $[66] = t24;
    $[67] = t26;
  } else {
    t26 = $[67];
  }
  let t27;
  if ($[68] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = e_0 => setFormData(prev_1 => ({
      ...prev_1,
      detailAddress: e_0.target.value
    }));
    $[68] = t27;
  } else {
    t27 = $[68];
  }
  let t28;
  if ($[69] !== formData.detailAddress) {
    t28 = <Input dimensions="H40" value={formData.detailAddress} onChange={t27} placeholder={"\uC0C1\uC138\uC8FC\uC18C\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694"} />;
    $[69] = formData.detailAddress;
    $[70] = t28;
  } else {
    t28 = $[70];
  }
  let t29;
  if ($[71] !== t26 || $[72] !== t28) {
    t29 = <InputDecorator label={"\uC8FC\uC18C"} required={true}><div className="flex flex-col gap-8">{t26}{t28}</div></InputDecorator>;
    $[71] = t26;
    $[72] = t28;
    $[73] = t29;
  } else {
    t29 = $[73];
  }
  let t30;
  if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = e_1 => setFormData(prev_2 => ({
      ...prev_2,
      phone: e_1.target.value
    }));
    $[74] = t30;
  } else {
    t30 = $[74];
  }
  let t31;
  if ($[75] !== formData.phone) {
    t31 = <InputDecorator label={"\uD734\uB300\uD3F0 \uBC88\uD638"} required={true}><Input dimensions="H40" type="tel" inputMode="numeric" value={formData.phone} onChange={t30} placeholder={"\uD734\uB300\uD3F0 \uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694"} /></InputDecorator>;
    $[75] = formData.phone;
    $[76] = t31;
  } else {
    t31 = $[76];
  }
  let t32;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = e_2 => setFormData(prev_3 => ({
      ...prev_3,
      name: e_2.target.value
    }));
    $[77] = t32;
  } else {
    t32 = $[77];
  }
  let t33;
  if ($[78] !== formData.name) {
    t33 = <InputDecorator label={"\uBC30\uC1A1\uC9C0\uBA85"}><Input dimensions="H40" value={formData.name} onChange={t32} placeholder={"\uC6B0\uB9AC\uC9D1"} /></InputDecorator>;
    $[78] = formData.name;
    $[79] = t33;
  } else {
    t33 = $[79];
  }
  let t34;
  if ($[80] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = e_3 => setFormData(prev_4 => ({
      ...prev_4,
      entrancePasscode: e_3.target.value
    }));
    $[80] = t34;
  } else {
    t34 = $[80];
  }
  let t35;
  if ($[81] !== formData.entrancePasscode) {
    t35 = <InputDecorator label={"\uACF5\uB3D9\uD604\uAD00 \uBE44\uBC00\uBC88\uD638"}><Input dimensions="H40" value={formData.entrancePasscode} onChange={t34} placeholder={"\uC608: #1234*"} /></InputDecorator>;
    $[81] = formData.entrancePasscode;
    $[82] = t35;
  } else {
    t35 = $[82];
  }
  let t36;
  if ($[83] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = checked => setFormData(prev_5 => ({
      ...prev_5,
      isPrimary: !!checked
    }));
    $[83] = t36;
  } else {
    t36 = $[83];
  }
  let t37;
  if ($[84] !== formData.isPrimary) {
    t37 = <Checkbox checked={formData.isPrimary} onCheckedChange={t36} />;
    $[84] = formData.isPrimary;
    $[85] = t37;
  } else {
    t37 = $[85];
  }
  let t38;
  if ($[86] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <span className="font-400 text-Gray-900 typo-body4">기본 배송지로 선택</span>;
    $[86] = t38;
  } else {
    t38 = $[86];
  }
  let t39;
  if ($[87] !== t37) {
    t39 = <div className="flex items-center gap-4">{t37}{t38}</div>;
    $[87] = t37;
    $[88] = t39;
  } else {
    t39 = $[88];
  }
  let t40;
  if ($[89] !== t23 || $[90] !== t29 || $[91] !== t31 || $[92] !== t33 || $[93] !== t35 || $[94] !== t39) {
    t40 = <div className="flex flex-1 flex-col gap-16 px-20 py-16">{t23}{t29}{t31}{t33}{t35}{t39}</div>;
    $[89] = t23;
    $[90] = t29;
    $[91] = t31;
    $[92] = t33;
    $[93] = t35;
    $[94] = t39;
    $[95] = t40;
  } else {
    t40 = $[95];
  }
  let t41;
  if ($[96] !== handleSave) {
    t41 = <Button onClick={handleSave} className="w-full">저장</Button>;
    $[96] = handleSave;
    $[97] = t41;
  } else {
    t41 = $[97];
  }
  let t42;
  if ($[98] !== address || $[99] !== handleDelete) {
    t42 = address && <Button theme="primary-text" className="w-full" onClick={handleDelete}>삭제</Button>;
    $[98] = address;
    $[99] = handleDelete;
    $[100] = t42;
  } else {
    t42 = $[100];
  }
  let t43;
  if ($[101] !== t41 || $[102] !== t42) {
    t43 = <footer className="sticky bottom-0 flex flex-col gap-8 bg-Gray-white px-20 py-12 pb-[calc(12px+var(--safe-area-bottom,0px))]">{t41}{t42}</footer>;
    $[101] = t41;
    $[102] = t42;
    $[103] = t43;
  } else {
    t43 = $[103];
  }
  let t44;
  if ($[104] !== t40 || $[105] !== t43) {
    t44 = <div className="flex min-h-full flex-col">{t40}{t43}</div>;
    $[104] = t40;
    $[105] = t43;
    $[106] = t44;
  } else {
    t44 = $[106];
  }
  let t45;
  if ($[107] !== onClose || $[108] !== opened || $[109] !== t20 || $[110] !== t21 || $[111] !== t44) {
    t45 = <ResponsiveDialog opened={opened} onClose={onClose} modalHeader={t20} title={t21} drawerType="full" isAppBarHeader={true}>{t44}</ResponsiveDialog>;
    $[107] = onClose;
    $[108] = opened;
    $[109] = t20;
    $[110] = t21;
    $[111] = t44;
    $[112] = t45;
  } else {
    t45 = $[112];
  }
  let t46;
  if ($[113] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = () => setShowAddressSearch(false);
    $[113] = t46;
  } else {
    t46 = $[113];
  }
  let t47;
  if ($[114] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = <DaumPostcodeEmbed onComplete={handleAddressComplete} />;
    $[114] = t47;
  } else {
    t47 = $[114];
  }
  let t48;
  if ($[115] !== showAddressSearch) {
    t48 = <Modal opened={showAddressSearch} onClose={t46} wrapperClassName="z-[60]" className="mobile:px-0">{t47}</Modal>;
    $[115] = showAddressSearch;
    $[116] = t48;
  } else {
    t48 = $[116];
  }
  let t49;
  if ($[117] !== t45 || $[118] !== t48) {
    t49 = <>{t45}{t48}</>;
    $[117] = t45;
    $[118] = t48;
    $[119] = t49;
  } else {
    t49 = $[119];
  }
  return t49;
};